function Packaging({ data, state, dispatch, setTab }) {
    return (
        <div className="tab">
            <div className="cols cols-v-2">
                <div>
                    <img src={data.packaging.image} />
                </div>
                <div>
                    <h1 className="title">{data.product.post_title}</h1>
                    <div className="copy" dangerouslySetInnerHTML={{ __html: data.packaging.content }}></div>
                </div>
            </div>
            <div className='tab__actions'>
                <button className='btn' onClick={() => setTab('size_and_quantity')}>Back</button>
                <button className='btn' onClick={() => setTab('summary')}>Next</button>
            </div>
        </div>
    )
}

export default Packaging
